<template>
	<ShopView>
		<h1 class="mb-6 d-flex align-center">
			{{ $t('pageTitles.shop.dataSheets') }}
		</h1>
		<AsiCard unwrapped>
			<v-card-text class="pa-6">

				<template v-for="(category, idx) in categories">
					<AsiCard
						:key="idx"
						:title="$t(`dataSheets.${category.i18nKey}`)"
						title-bg-color="transparent"
						class="mt-3"
						wrap-title
						flat
						no-bottom-margin
					>
						<v-card-text class="pl-0 px-md-3">
							<ul>
								<li v-for="entry in category.filenames" :key="entry">
									<a :href="getDataSheetUrl(category.key, entry)" target="_blank" download>
										{{ entry }}
									</a>
								</li>
							</ul>
						</v-card-text>
					</AsiCard>
					<v-divider v-if="idx < categories.length - 1" :key="idx"/>
				</template>

			</v-card-text>
		</AsiCard>
	</ShopView>
</template>

<script lang="ts">
	import {Vue, Component} from 'vue-property-decorator';
	import ShopView from "@/components/layout/ShopView.vue";
	import AsiCard from "@/components/common/AsiCard.vue";

	@Component({
		components: {AsiCard, ShopView}
	})

	export default class DataSheets extends Vue {

		public get categories() {
			return [
				{
					key: 'opti',
					i18nKey: 'categoryOpti',
					filenames: [
						'Opti 2003-45-exp', 'Opti 2003-45', 'Opti 2010-60', 'Opti 2011-70', 'Opti 2012-70', 'Opti 2018-80',
						'Opti 2019-60', 'Opti 2021-60', 'Opti 2022-60', 'Opti 2024-40', 'Opti 2026-85', 'Opti 2027-70',
						'Opti 2028-60', 'Opti 2030-85', 'Opti 2032-60', 'Opti 2038-60', 'Opti-B 2031-60'
					]
				},
				{
					key: 'star',
					i18nKey: 'categoryStar',
					filenames: [
						'Star 1002-55', 'Star 1004-65', 'Star 1007-70', 'Star 1011-55', 'Star 1012-80', 'Star 1014-55',
						'Star 1015-65'
					]
				},
				{
					key: 'sil',
					i18nKey: 'categorySil',
					filenames: [
						`SIL 11'006-65-7015`, `SIL 11'014-45`, `SIL 11'015-60`, `SIL 11'016-50`, `SIL 11'017-65-7040`,
						`SIL 11'018-70`, `SIL 11'019-70`, `SIL 11'025-60`, `SIL 11'032-50-7015`, `SIL 11’006-65-7015`
					]
				}
			];
		}

		public getDataSheetUrl(category: string, filename: string): string {
			// for the moment, the data sheets are only available in German
			return `https://prodchnorth02fdec83b4882.blob.core.windows.net/mk-dichtungen-poesia-webshop-assets/data-sheets/de/${category}/${encodeURIComponent(filename.trim())}.pdf`;
		}
	}
</script>

<style scoped lang="scss">

</style>